const styles = (theme) => ({
  dialog: {
    width: 470,
    backgroundColor: theme.gridBGColor,
  },
  stopName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  titleDivider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
  },
  stopAddress: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: 16,
  },
  deliveryBillsHeaderText: {
    color: theme.TextColor,
  },
  dialogWrapper: {},
  actionButton: {},
  submitButton: {
    width: "45%",
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    },
  },
  disabledButton: { width: "45%" },
  actionButtonManualEntry: {
    width: "50%",
  },
  manualEntryContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 16,
    alignItems: "center",
    marginBottom: 16,
  },
  manualEntryLabel: {
    color: theme.TextColor,
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
  },
  confirmDialogContent: {
    display: "flex",
    flexDirection: "column",
  },
  greenSubLabel: {
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    textTransform: "uppercase",
    color: theme.proNumberColor,
  },
  headerLabel: {
    fontSize: theme.dispatchCardTextFontSize,
    marginTop: 8,
    fontWeight: 500,
    textTransform: "uppercase",
    color: theme.dispatchPanelLabelValueColor,
  },
  dialogActionsClass: {
    width: "100%",
    justifyContent: "space-between",
  },
  divider: {
    backgroundColor: theme.AppBGColor,
  },
});

export default styles;
